<!-- Start Forgot Password Area -->
<div class="forgot-password-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="forgot-password-content">
                <div class="row m-0">
                    <div class="col-lg-5 p-0">
                        <div class="image">
                            <i class="bx bx-at image-forgot"></i>
                        </div>
                    </div>

                    <div class="col-lg-7 p-0">
                        <div class="forgot-password-form">
                            <h2>¿Olvidaste tu contraseña?</h2>
                            <p class="mb-0">Por favor, ingresa tu correo para cambiar la contraseña</p>

                            <form [formGroup]="formForgot" (ngSubmit)="submitForgot()">
                                <div class="form-group">
                                    <input type="email" formControlName="email" class="form-control" name="name"
                                        placeholder="Correo" (focus)="response=''">
                                    <span class="label-title"><i class='bx bx-envelope'></i></span>
                                </div>
                                <div class="alert alert-info alert-custom" role="alert"
                                    [class.shake-horizontal]="formForgot.get('email').hasError('pattern')"
                                    *ngIf="formForgot.get('email').hasError('pattern') && (formForgot.get('email').dirty || formForgot.get('email').touched)">
                                    <span>
                                        <i class="bx bx-help-circle"></i>El email debe ser de la siguiente forma
                                        <b>usuario@serviciodecorreo.com</b>
                                    </span>
                                </div>
                                <div class="alert alert-{{typeResponse}}" role="alert"
                                    [class.shake-horizontal]="response!=''"
                                    *ngIf="response!=''">
                                    <span>
                                        <i *ngIf="typeResponse=='info'" class="bx bxs-check-circle"></i>
                                        <i *ngIf="typeResponse=='danger'" class="bx bx-error"></i>
                                        {{response}}
                                    </span>
                                </div>
                                <button type="submit" [disabled]="!formForgot.valid" class="forgot-password-btn btn">
                                    <div *ngIf="wait" class="spinner-border" role="status">
                                    </div> <span *ngIf="!wait">Cambiar Contraseña</span>
                                </button>
                            </form>
                            <p class="mb-0">Ya me acordé, <a routerLink="/authentication/login"> regresar a login<i
                                        width="1em" data-feather='corner-up-left'></i></a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Forgot Password Area -->